export default __webpack_public_path__ + "static/backgroundAwards--blurV-95083f8f8a24ebb1d2d99ce853e42733.jpg";